import React, { useState, useEffect } from "react";
import { HiOutlineSpeakerWave, HiChevronRight } from "react-icons/hi2";
import { TbNotes } from "react-icons/tb";
import { PiStack } from "react-icons/pi";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { SlLogout } from "react-icons/sl";
import LogoutModal from "../../../../Components/Modals/LogoutModal";
import { useCookies } from "react-cookie";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import profile_Img from "../../../../Assets/Images/user.png";
import { toast } from "react-toastify";
import {
  postApiCaller,
  postFormDataApiCaller,
} from "../../../../Libs/apiCaller";
import { logedInUser } from "../../../../Redux/slices/AuthSlice";
import { PiClipboardTextThin } from "react-icons/pi";
import { GoChevronRight } from "react-icons/go";
import { PiShieldCheckThin } from "react-icons/pi";

export default function SettingsList({ setView }) {
  const [muteNotifications, setMuteNotifications] = useState(false);
  const [openLogoutConfirmModal, setOpenLogoutConfirmModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { userInfo, fcmToken } = useSelector((state) => state.authUser);
  const [, , removeCookie] = useCookies(["accessToken"]);
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownStates, setDropdownStates] = useState({
    groups: false,
    tos: false,
    pp: false,
    about: false,
    help: false,
    logout: false,
  });
  const [timeoutId, setTImeoutId] = useState(null);
  const dispatch = useDispatch();

  const toggleDropdown = (key) => {
    setDropdownStates((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleNameClick = () => {
    setView("view"); // Switch to the settings view
  };

  const [showNotif, setShowNotif] = useState(false);

  useEffect(() => {
    if (userInfo?.isMuted) {
      setMuteNotifications(true);
    } else {
      setMuteNotifications(false);
    }
    setTimeout(() => {
      setShowNotif(true);
    }, 50);
  }, [userInfo?.isMuted]);

  const settingItems = [
    // {
    //   key: "groups",
    //   icon: <HiOutlineUserGroup className="text-lg" />,
    //   label: "Joined Groups",
    // },
    {
      key: "tos",
      icon: <PiClipboardTextThin className="text-lg" />,
      label: "Terms Of Service",
      path: "/settings/terms-and-conditions",
    },
    {
      key: "pp",
      icon: <PiShieldCheckThin className="text-lg" />,
      label: "Privacy Policy",
      path: "/settings/privacy-policy",
    },
    {
      key: "about",
      icon: <PiStack className="text-lg" />,
      label: "About App",
      path: "/settings/about-us",
    },
    {
      key: "help",
      icon: <IoIosHelpCircleOutline className="text-lg" />,
      label: "Help Center",
      path: "/settings/help-center",
    },
    // { key: "logout", icon: <CgLogOut className="text-lg" />, label: "Logout" },
  ];

  const handleLogoutClick = () => {
    setOpenLogoutConfirmModal(true);
  };

  const logoutConfirm = async () => {
    setIsLoading(true);
    const endPoint = "auth/logout";
    const payload = {
      fcmToken: fcmToken,
    };
    const response = await postApiCaller(endPoint, payload);
    if (response?.status === 200) {
      localStorage.removeItem("userId");
      removeCookie("accessToken", {
        path: "/",
        secure: true,
        httpOnly: false,
        sameSite: "Strict",
      }); // Remove authentication token
      setOpenLogoutConfirmModal(false);
      toast.success("Logged out successfully");
      navigate("/sign-in");
    } else {
      toast.error(response?.response?.data?.message || response?.message);
    }
    setIsLoading(false);
  };

  const handleUpdateProfile = async (muteNotifications) => {
    const formData = new FormData();
    // formData.append("userID", userInfo._id);
    formData.append("isMuted", muteNotifications);
    const endPoint = "users/update_user";
    const response = await postFormDataApiCaller(endPoint, formData);
    if (response?.status === 200) {
      dispatch(logedInUser({ ...response.data.user }));
    } else {
      toast.error(response?.response?.data?.message || response?.message);
    }
  };

  return (
    <section>
      <div className="my-1 bg-white dark:bg-slate-800 pb-4 px-3 rounded-lg space-y-6">
        {/* Profile Section */}
        <div className="flex items-center pb-2">
          <img
            alt="avatar"
            className="w-[46px] h-[46px] rounded-full object-cover cursor-pointer"
            src={
              userInfo?.avtarImage ||
              userInfo?.userImage ||
              userInfo?.userMedia ||
              profile_Img
            }
            onClick={handleNameClick}
          />
          <div className="flex flex-col justify-start ml-3">
            <span
              className="cursor-pointer hover:text-[var(--primary-color)] font-semibold text-lg text-black"
              onClick={handleNameClick}
            >
              {" "}
              {userInfo?.name}
            </span>
          </div>
        </div>

        {/* Mute Notification */}
        <div className="flex justify-between items-center">
          <p className="text-[15px] flex items-center gap-4 text-black font-semibold">
            <HiOutlineSpeakerWave className="text-lg" /> Mute Notifications
          </p>
          <label htmlFor="toggle" className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              id="toggle"
              className="sr-only peer"
              checked={muteNotifications}
              onChange={(ev) => {
                setMuteNotifications(ev.target.checked);
                if (timeoutId) {
                  clearTimeout(timeoutId);
                }
                setTImeoutId(
                  setTimeout(() => handleUpdateProfile(ev.target.checked), 500)
                );
              }}
            />
            <div
              className={`${showNotif ? "block" : "hidden"
                } relative w-12 h-6 p-1 rounded-full bg-gray-300 peer-checked:bg-[linear-gradient(131.7deg,_#7404FE_3.53%,_#42058E_133.97%)] transition-colors duration-300 before:absolute before:bg-white before:w-4 before:h-4 before:rounded-full before:transition-all before:duration-500 before:left-1 peer-checked:before:left-7`}
            ></div>
          </label>
        </div>

        {/* Settings Items */}
        {settingItems.map((item) => (
          <div
            key={item.key}
            className="flex justify-between items-center cursor-pointer"
            onClick={() => navigate(item.path)}
          >
            <button
              onClick={() => navigate(item.path)}
              className="items-center"
              disabled={item.path === location.pathname}
            >
              <p className="text-[15px] flex items-center gap-4 text-black font-semibold">
                {item.icon}
                {item.label}
              </p>
            </button>
            <GoChevronRight size={22} />
          </div>
        ))}
        <div
          className="cursor-pointer w-fit"
          onClick={() => handleLogoutClick()}
        >
          <button className="text-[#F44336] flex font-semibold items-center gap-4.5 text-[15px]">
            <SlLogout className="text-md" /> Logout
          </button>
        </div>
      </div>
      <LogoutModal
        isOpen={openLogoutConfirmModal}
        onClose={() => setOpenLogoutConfirmModal(false)}
        onLogout={() => logoutConfirm()}
        isLoading={isLoading}
      />
    </section>
  );
}
